import React, { useEffect, useState } from "react"
import Modal from "react-modal"
import { useModal } from "./modalContext"
import { RiCloseLargeFill } from "react-icons/ri"
import { useUser } from "./userContext"
import Cookies from "js-cookie"
import authApi from "../api/authApi"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const AuthModal = () => {
  const { isModalOpen, closeModal, activeTab, setActiveTab } = useModal()
  const { setUser, setToken } = useUser()

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  })

  const [registerData, setRegisterData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    password: "",
    acceptTerms: false,
  })

  const [errors, setErrors] = useState({
    login: {},
    register: {},
  })

  const [isFormValid, setIsFormValid] = useState(false)

  // Reset form data when modal closes
  useEffect(() => {
    if (!isModalOpen) {
      setLoginData({ email: "", password: "" })
      setRegisterData({
        username: "",
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        acceptTerms: false,
      })
      setErrors({ login: {}, register: {} })
      setIsFormValid(false)
    }
  }, [isModalOpen])

  // Handle tab changes
  useEffect(() => {
    if (activeTab === "login") {
      setRegisterData({
        username: "",
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        acceptTerms: false,
      })
      setErrors(prev => ({ ...prev, register: {} }))
    } else {
      setLoginData({ email: "", password: "" })
      setErrors(prev => ({ ...prev, login: {} }))
    }
  }, [activeTab])

  // Validate forms
  useEffect(() => {
    if (activeTab === "login") {
      const isValid = Object.keys(errors.login).length === 0 && 
                     loginData.email && 
                     loginData.password
      setIsFormValid(isValid)
    } else {
      const isValid = Object.keys(errors.register).length === 0 &&
                     registerData.username &&
                     registerData.first_name &&
                     registerData.last_name &&
                     registerData.email &&
                     registerData.password &&
                     registerData.acceptTerms
      setIsFormValid(isValid)
    }
  }, [
    activeTab,
    loginData.email,
    loginData.password,
    registerData.username,
    registerData.first_name,
    registerData.last_name,
    registerData.email,
    registerData.password,
    registerData.acceptTerms,
    errors.login,
    errors.register
  ])

  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }
  const validatePassword = password => password.length >= 6
  const validateUsername = username => username.trim().length > 2

  const handleLoginChange = e => {
    const { id, value } = e.target
    setLoginData(prev => ({ ...prev, [id]: value }))

    let newErrors = { ...errors.login }

    if (id === "email") {
      if (value && !validateEmail(value)) {
        newErrors.email = "Format i pavlefshëm i emailit."
      } else {
        delete newErrors.email
      }
    } else if (id === "password") {
      if (value && !validatePassword(value)) {
        newErrors.password = "Fjalëkalimi duhet të ketë të paktën 6 karaktere."
      } else {
        delete newErrors.password
      }
    }

    setErrors(prev => ({ ...prev, login: newErrors }))

    setIsFormValid(
      Object.keys(newErrors).length === 0 &&
        value &&
        loginData.email &&
        loginData.password
    )
  }

  const handleRegisterChange = e => {
    const { id, value, type, checked } = e.target
    const fieldValue = type === 'checkbox' ? checked : value
    setRegisterData(prev => ({ ...prev, [id]: fieldValue }))

    let newErrors = { ...errors.register }

    if (id === "username") {
      if (fieldValue && !validateUsername(fieldValue)) {
        newErrors.username = "Username duhet të ketë të paktën 3 karaktere."
      } else {
        delete newErrors.username
      }
    } else if (id === "email") {
      if (fieldValue && !validateEmail(fieldValue)) {
        newErrors.email = "Format i pavlefshëm i emailit."
      } else {
        delete newErrors.email
      }
    } else if (id === "password") {
      if (fieldValue && !validatePassword(fieldValue)) {
        newErrors.password = "Fjalëkalimi duhet të ketë të paktën 6 karaktere."
      } else {
        delete newErrors.password
      }
    }

    setErrors(prev => ({ ...prev, register: newErrors }))

    // Update form validity with current values
    const updatedData = { ...registerData, [id]: fieldValue }
    setIsFormValid(
      Object.keys(newErrors).length === 0 &&
        updatedData.username &&
        updatedData.first_name &&
        updatedData.last_name &&
        updatedData.email &&
        updatedData.password &&
        updatedData.acceptTerms
    )
  }

  const handleLoginSubmit = async e => {
    e.preventDefault()
    if (Object.keys(errors.login).length === 0) {
      try {
        const response = await authApi.login(loginData)
        if (
          response &&
          response.data &&
          response.data.user &&
          response.data.user.username
        ) {
          Cookies.set("user", JSON.stringify(response.data.user), {
            expires: 1,
            secure: true,
          })
          Cookies.set("token", response.data.access_token, {
            expires: 1,
            secure: true,
          })
          console.log(Cookies.get("user"))
          setUser(response.data.user)
          setToken(response.data.access_token)

          toast.success(
            `Hyrja u krye me sukses! Mirë se vini ${response.data.user.username}`,
            {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          )

          setTimeout(() => {
            closeModal()
          }, 2000)
        } else {
          console.error("Unexpected response structure:", response)
          toast.error("Përgjigje e papritur nga serveri. Ju lutemi provoni përsëri.", {
            position: "top-center",
          })
        }
      } catch (error) {
        let errorMessage
        if (error.response && error.response.status === 401) {
          errorMessage = "Email ose fjalëkalim i gabuar. Ju lutemi provoni përsëri."
        } else {
          errorMessage =
            error.response?.data?.message ||
            "Ndodhi një gabim. Ju lutemi provoni përsëri."
        }
        toast.error(errorMessage, { position: "top-center" })
        console.error("Error:", error.response?.data?.message)
      }
    }
  }

  const handleRegisterSubmit = async e => {
    e.preventDefault()
    if (Object.keys(errors.register).length === 0) {
      try {
        const response = await authApi.register(registerData)
        Cookies.set("user", JSON.stringify(response.data.user), {
          expires: 1,
          secure: true,
        })
        Cookies.set("token", response.data.access_token, {
          expires: 1,
          secure: true,
        })
        setUser(response.data.user)
        setToken(response.data.access_token)
        toast.success(
          `Regjistrimi u krye me sukses! ${response.data.user.username}`,
          {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        )

        setTimeout(() => {
          closeModal()
        }, 2000)
      } catch (error) {
        if (error.response && error.response.data) {
          const backendErrors = error.response.data
          Object.entries(backendErrors).forEach(([_, messages]) => {
            messages.forEach(message => {
              toast.error(message, { position: "top-center" })
            })
          })
        } else {
          let errorMessage =
            error.response?.data?.message ||
            "Ndodhi një gabim. Ju lutemi provoni përsëri."
          toast.error(errorMessage, { position: "top-center" })
        }
        console.error("Register Error:", error.response?.data)
      }
    }
  }

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black-500 bg-opacity-85 transition-opacity duration-1000"
      style={{
        overlay: { zIndex: 1000 },
        content: { zIndex: 1001 },
      }}
      ariaHideApp={false}
    >
      <div className="relative px-4 w-full max-w-md max-h-sm bg-navColor rounded-lg shadow z-30 dark:bg-gray-700">
        <div className="flex items-center justify-between p-4 md:p-3 border-b rounded-t dark:border-gray-600">
          <h3 className="text-[17px] font-bold text-[#1C1917]">
            {activeTab === "login"
              ? "Hyni në llogarinë tuaj"
              : "Krijoni llogarinë tuaj"}
          </h3>
          <button
            type="button"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
            onClick={closeModal}
          >
            <RiCloseLargeFill />
            <span className="sr-only">Mbyll modalin</span>
          </button>
        </div>

        <div className="p-2 md:p-5">
          <div className="flex justify-center mb-4">
            <button
              className={`w-1/2 text-sm font-medium py-1 border-b-2 ${
                activeTab === "login"
                  ? "border-rose-950 text-rose-950"
                  : "border-transparent text-gray-600 hover:text-rose-950"
              }`}
              onClick={() => setActiveTab("login")}
            >
              Hyni
            </button>
            <button
              className={`w-1/2 text-sm font-medium py-1 border-b-2 ${
                activeTab === "signup"
                  ? "border-rose-950 text-rose-950"
                  : "border-transparent text-gray-600 hover:text-rose-950"
              }`}
              onClick={() => setActiveTab("signup")}
            >
              Regjistrohuni
            </button>
          </div>

          {activeTab === "login" ? (
            <form onSubmit={handleLoginSubmit} className="space-y-4">
              <div>
                <label
                  htmlFor="email"
                  className="block mb-2 text-xs font-medium text-[#1C1917]"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={loginData.email}
                  onChange={handleLoginChange}
                  required
                  autoComplete="off"
                  className="border border-gray-300 text-gray-900 text-xs block h-1/2 w-full p-2.5 focus:ring-red-950"
                />
                {errors.login.email && (
                  <p className="text-red-500 text-xs">{errors.login.email}</p>
                )}
              </div>
              <div>
                <label
                  htmlFor="password"
                  className="block mb-2 text-xs font-medium text-[#1C1917]"
                >
                  Fjalëkalimi
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={loginData.password}
                  onChange={handleLoginChange}
                  required
                  autoComplete="off"
                  className="border border-gray-300 text-gray-900 text-xs block h-1/2 w-full p-2.5 focus:ring-red-950"
                />
                {errors.login.password && (
                  <p className="text-red-500 text-xs">
                    {errors.login.password}
                  </p>
                )}
              </div>
              <button
                type="submit"
                disabled={!isFormValid}
                className={`w-full h-1/2 text-white ${
                  !isFormValid
                    ? "bg-gray-400"
                    : "bg-customOrange hover:bg-[#b73f1d]"
                } focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center`}
              >
                Hyni
              </button>
              <div className="text-xs font-medium mr-5 text-gray-500 dark:text-gray-300">
                Nuk jeni regjistruar?
                <button
                  onClick={() => setActiveTab("signup")}
                  className="text-red-950 p-1 cursor-pointer hover:underline bg-transparent border-0"
                >
                  Krijoni llogari
                </button>
              </div>
            </form>
          ) : (
            <form onSubmit={handleRegisterSubmit} className="space-y-4">
              <div>
                <label
                  htmlFor="username"
                  className="block mb-1 text-[10px] font-medium text-[#1C1917]"
                >
                  Username
                </label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={registerData.username}
                  onChange={handleRegisterChange}
                  required
                  autocomplete="one-time-code"
                  className="border border-gray-300 text-gray-900 text-xs block h-8 w-full p-1 focus:ring-red-950"
                />
                {errors.register.username && (
                  <p className="text-red-500 text-[10px]">
                    {errors.register.username}
                  </p>
                )}
              </div>
              <div>
                <label
                  htmlFor="first_name"
                  className="block mb-1 text-[10px] font-medium text-[#1C1917]"
                >
                  Emri
                </label>
                <input
                  type="text"
                  id="first_name"
                  name="first_name"
                  value={registerData.first_name}
                  onChange={handleRegisterChange}
                  required
                  autocomplete="one-time-code"
                  className="border border-gray-300 text-gray-900 text-xs block h-8 w-full p-1 focus:ring-red-950"
                />
              </div>
              <div>
                <label
                  htmlFor="last_name"
                  className="block mb-1 text-[10px] font-medium text-[#1C1917]"
                >
                  Mbiemri
                </label>
                <input
                  type="text"
                  id="last_name"
                  name="last_name"
                  value={registerData.last_name}
                  onChange={handleRegisterChange}
                  required
                  autocomplete="one-time-code"
                  className="border border-gray-300 text-gray-900 text-xs block h-8 w-full p-1 focus:ring-red-950"
                />
              </div>
              <div>
                <label
                  htmlFor="email-signup"
                  className="block mb-1 text-[10px] font-medium text-[#1C1917]"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={registerData.email}
                  onChange={handleRegisterChange}
                  required
                  autocomplete="one-time-code"
                  className="border border-gray-300 text-gray-900 text-xs block h-8 w-full p-1 focus:ring-red-950"
                />
                {errors.register.email && (
                  <p className="text-red-500 text-[10px]">
                    {errors.register.email}
                  </p>
                )}
              </div>
              <div>
                <label
                  htmlFor="password-signup"
                  className="block mb-1 text-[10px] font-medium text-[#1C1917]"
                >
                  Fjalëkalimi
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={registerData.password}
                  onChange={handleRegisterChange}
                  required
                  autocomplete="one-time-code"
                  className="border border-gray-300 text-gray-900 text-xs block h-8 w-full p-1 focus:ring-red-950"
                />
                {errors.register.password && (
                  <p className="text-red-500 text-[10px]">
                    {errors.register.password}
                  </p>
                )}
              </div>
                              <div>
                  <label
                    htmlFor="acceptTerms"
                    className="flex items-start"
                  >
                    <input
                      type="checkbox"
                      id="acceptTerms"
                      name="acceptTerms"
                      checked={registerData.acceptTerms}
                      onChange={handleRegisterChange}
                      required
                      className="mr-2 mt-1 border border-gray-300 rounded focus:ring-red-950"
                    />
                    <span className="text-xs font-medium text-gray-500 dark:text-gray-300">
                      Unë pranoj{" "}
                      <button
                        type="button"
                        onClick={() => window.open('/terms-and-conditions', '_blank')}
                        className="text-red-950 hover:underline bg-transparent border-0 p-0"
                      >
                        kushtet dhe afatet e perdorimit
                      </button>
                    </span>
                  </label>
                  {!registerData.acceptTerms && Object.keys(errors.register).length === 0 && registerData.username && registerData.first_name && registerData.last_name && registerData.email && registerData.password && (
                    <p className="text-red-500 text-[10px] mt-1">
                      Duhet të pranoni kushtet dhe afatet e perdorimit per t'u regjistruar
                    </p>
                  )}
                </div>
              <button
                type="submit"
                disabled={!isFormValid}
                className={`w-full h-1/2 text-white ${
                  !isFormValid
                    ? "bg-gray-400"
                    : "bg-customOrange hover:bg-[#b73f1d]"
                } focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center`}
              >
                Krijoni llogarinë
              </button>
            </form>
          )}
        </div>
      </div>
      <ToastContainer />
    </Modal>
  )
}

export default AuthModal
